import {computed} from '@angular/core';
import {patchState, signalStore, withComputed, withMethods, withState} from '@ngrx/signals';
import {randomUuid} from 'src/app/domain/util/uuid/uuid';

export const dropAPinMessage = "Drag the map to select a location and press the locator icon to confirm or cancel.";

export enum InternalNotificationType {
  ERROR = 'ERROR',
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING'
}

export interface InternalNotification {
  id: string,
  message: string,
  techDetails?: string,
  type: InternalNotificationType,
  persist: boolean,
  replacementKey?: string
}

interface InternalNotificationsState {
  notifications: InternalNotification[]
}

const initialState: InternalNotificationsState = {
  notifications: []
};

export const InternalNotificationsStore = signalStore(
  {providedIn: 'root'},
  withState(initialState),
  withComputed(({notifications}) => ({
    notification: computed(() => {
      return notifications()[0];
    })
  })),
  withMethods((store) => ({
      addNotification(message: string, type: InternalNotificationType, persist: boolean, replacementKey?: string, techDetails?: string): InternalNotification {
        const newNotification = {
          message: message,
          techDetails: techDetails,
          id: randomUuid(),
          type: type,
          persist: persist,
          replacementKey: replacementKey
        };
        const currentNotification = store.notification();

        if (replacementKey !== undefined && currentNotification?.replacementKey === replacementKey) {
          const notifications = [newNotification, ...store.notifications().slice(1)];
          patchState(store, {notifications});
        } else {
          const notifications = [...store.notifications(), newNotification];
          patchState(store, {notifications});
        }

        return newNotification;
      },
      deleteNotification(notification: InternalNotification) {
        const notifications = store.notifications().filter(n => n.id !== notification.id);
        patchState(store, {notifications});
      }
    })
  ));
